import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Products from 'views/cash/closeBox-edit/products'; // Importing Products view
import OtherExpenses from 'views/cash/closeBox-edit/otherExpenses'; // Importing OtherExpenses view
import OtherIncome from 'views/cash/closeBox-edit/otherIncome'; // Importing OtherIncome view
import CreditCards from 'views/cash/closeBox-edit/creditCards'; // Importing CreditCards view
import Total from 'views/cash/closeBox-edit/total'; // Importing Total view
import { devConfig, profile } from 'config/config'; // Importing development configuration and user profile

/**
 * Class representing the activation of the registration view.
 * @extends JetView
 */
export default class activateRegistrationView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const vthis = this; // Reference to the current instance

        // Check if cash box is already closed
        if (profile.CloseCashBox) {
            vthis.show('/top/'); // Redirect to top view
            webix.alert({
                type: 'alert-error',
                title: 'Error',
                text: _('Ya se efectuó el cierre de día, no es posible realizar esta operación'), // Alert message in Spanish
            });
        }

        // Configuration for products section
        const products = {
            css: 'int-left',
            rows: [Products], // Including Products view
        };

        // Configuration for other expenses section
        const otherExpenses = {
            css: 'int-left',
            rows: [OtherExpenses], // Including OtherExpenses view
        };

        // Configuration for credit cards section
        const creditCards = {
            css: 'int-left',
            rows: [CreditCards], // Including CreditCards view
        };

        // Configuration for other income section
        const otherIncome = {
            css: 'int-left',
            rows: [OtherIncome], // Including OtherIncome view
        };

        // Configuration for total section
        const total = {
            css: 'int-left',
            rows: [Total], // Including Total view
        };

        /**
         * Function to handle cashier view display.
         * @param {string} id - The ID of the cashier.
         */
        function cashierView(id) {
            vthis.app.callEvent('viewCashier', [{ Id: id }]); // Trigger event to view cashier
            $$('cajero').setValue('Cajero ' + id); // Set cashier ID in the UI
            $$('BtnAddExpensesContainer').hide(); // Hide expenses button container
            $$('BtnAddIncomesContainer').hide(); // Hide incomes button container
            $$('BtnAddCreditCardContainer').hide(); // Hide credit card button container
            $$('gridProduct2').hide(); // Hide product grid
            $$('totalAccordion').hide(); // Hide total accordion
        }

        var obj = [{}]; // Initialize an empty object array
        const btnViewCashiers = [
            {
                view: 'button',
                id: 'btnViewCashiers',
                name: 'btnViewCashiers',
                css: 'back-button',
                type: 'icon',
                label: _('Volver'), // Back button label in Spanish
                icon: 'wxi-angle-left', // Back button icon
                click: function () {
                    vthis.app.callEvent('viewCashier', [{ Id: '' }]); // Trigger event to reset cashier view
                    webix.ui(btnViewBetShop, this.getParentView()); // Show bet shop view
                    $$('cajero').hide(); // Hide cashier ID field
                    $$('BtnAddExpensesContainer').show(); // Show expenses button container
                    $$('BtnAddIncomesContainer').show(); // Show incomes button container
                    $$('BtnAddCreditCardContainer').show(); // Show credit card button container
                    $$('gridProduct2').show(); // Show product grid
                    $$('totalAccordion').show(); // Show total accordion
                },
            },
        ];

        // AJAX request to fetch cashier data
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetCashierSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Display error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response text to JSON
                    obj = resp.Data; // Store cashier data
                    var cont = 0; // Initialize counter
                    while (cont < obj.length) {
                        btnViewCashiers.push({
                            view: 'button',
                            id: obj[cont].id, // Set button ID to cashier ID
                            name: obj[cont].id, // Set button name to cashier ID
                            label: 'Cajero ' + obj[cont].id, // Button label
                            click: function (id, event) {
                                cashierView(id); // Call cashier view function
                            },
                        });
                        cont = cont + 1; // Increment counter
                    }
                },
            });

        // Configuration for bet shop view buttons
        const btnViewBetShop = [
            {
                hidden: devConfig.getPermAction('btnViewCashiers', 'Add'), // Check permission to view cashiers
                css: 'prm-btnViewCashiers',
            },
            {
                view: 'button',
                value: _('Ver por un cajero en especifico'), // Button label in Spanish
                click: function () {
                    webix.ui(btnViewCashiers, this.getParentView()); // Show cashier buttons
                    $$('cajero').show(); // Show cashier ID field
                },
                hidden: !devConfig.getPermAction('btnViewCashiers', 'Add'), // Check permission to view cashiers
                css: 'prm-btnViewCashiers',
            },
        ];

        webix.ui.fullScreen(); // Set UI to full screen mode

        // Configuration for upper section of the view
        const upper_section = {
            id: 'b5',
            rows: [
                {
                    collapsed: true,
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    margin: 15,
                    responsive: 'b5',
                    scroll: true,
                    cols: [
                        {
                            rows: [
                                {
                                    cols: [
                                        {
                                            hidden: devConfig.getPermAction('btnViewCashiers', 'Add'), // Check permission to view cashiers
                                            css: 'prm-btnViewCashiers',
                                        },
                                        {
                                            view: 'toolbar',
                                            hidden: !devConfig.getPermAction('btnViewCashiers', 'Add'), // Check permission to view cashiers
                                            css: 'prm-btnViewCashiers',
                                            elements: [
                                                {
                                                    view: 'button',
                                                    value: _(
                                                        'Ver por un cajero en especifico', // Button label in Spanish
                                                    ),
                                                    click: function () {
                                                        webix.ui(
                                                            btnViewCashiers,
                                                            this.getParentView(), // Show cashier buttons
                                                        );
                                                        $$('cajero').show(); // Show cashier ID field
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    hidden: !devConfig.getPermAction('btnViewCashiers', 'Add') && !obj.length > 0, // Check permission and if there are cashiers
                                    css: 'prm-btnViewCashiers',
                                    view: 'text',
                                    id: 'cajero', // Cashier ID field
                                    value: 'Cajero #', // Default value
                                    disabled: true, // Field is read-only
                                    css: 'dashboard-stats',
                                },
                                {
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    responsive: 'b5',
                                    cols: [
                                        {
                                            id: '9',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: false,
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: _('Productos'), // Header for products section
                                                    body: {
                                                        rows: [products], // Include products view
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    responsive: 'b5',
                                    cols: [
                                        {
                                            id: '10',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: false,
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: _('Otros Egresos'), // Header for other expenses section
                                                    body: {
                                                        rows: [
                                                            {
                                                                id: 'BtnAddExpensesContainer', // Container for add expenses button
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        view: 'button',
                                                                        value: _(
                                                                            'Añadir Egreso', // Button label in Spanish
                                                                        ),
                                                                        width: 120,
                                                                        id: 'BtnAddExpenses', // Button ID
                                                                        click: () => {
                                                                            this.app.callEvent('expensesAdd', [{}]); // Trigger event to add expenses
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                            otherExpenses, // Include other expenses view
                                                        ],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    responsive: 'b5',
                                    cols: [
                                        {
                                            id: '10',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: false,
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: _('Otros Ingresos'), // Header for other income section
                                                    body: {
                                                        rows: [
                                                            {
                                                                id: 'BtnAddIncomesContainer', // Container for add incomes button
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        view: 'button',
                                                                        value: _(
                                                                            'Añadir Ingreso', // Button label in Spanish
                                                                        ),
                                                                        id: 'BtnAddIncomes', // Button ID
                                                                        width: 150,
                                                                        click: () => {
                                                                            this.app.callEvent('incomesAdd', [{}]); // Trigger event to add incomes
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                            otherIncome, // Include other income view
                                                        ],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    responsive: 'b5',
                                    cols: [
                                        {
                                            id: '10',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: false,
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: _(
                                                        'Ingresos Tarjetas de crédito', // Header for credit card income section
                                                    ),
                                                    body: {
                                                        rows: [
                                                            {
                                                                id: 'BtnAddCreditCardContainer', // Container for add credit card button
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        view: 'button',
                                                                        value: _(
                                                                            'Añadir ingreso por tarjeta', // Button label in Spanish
                                                                        ),
                                                                        id: 'BtnAddCreditCard', // Button ID
                                                                        width: 250,
                                                                        click: () => {
                                                                            this.app.callEvent('creditCardsAdd', [{}]); // Trigger event to add credit card income
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                            creditCards, // Include credit cards view
                                                        ],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            collapsed: true,
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            margin: 15,
                            responsive: 'b5',
                            width: 250,
                            id: 'totalAccordion', // ID for total accordion
                            cols: [
                                {
                                    id: '9',
                                    multi: true,
                                    view: 'accordion',
                                    css: 'betShop',
                                    collapsed: false,
                                    paddingY: 10,
                                    type: 'clean',
                                    rows: [
                                        {
                                            header: 'Total', // Header for total section
                                            body: {
                                                rows: [total], // Include total view
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Return the main configuration object for the view
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            hidden: !devConfig.getPermAction('editCloseBox', 'Edit'), // Check permission to edit close box
            css: 'prm-editCloseBox',
            rows: [
                {
                    height: 'auto',
                    responsive: 'a5',
                    type: 'wide',
                    cols: [upper_section], // Include upper section in the layout
                },
            ],
        };
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        $$('cajero').hide(); // Hide cashier ID field initially
        const _ = this.app.getService('locale')._; // Localization service
        webix.ready(function () {
            if (screen.width < 500) {
                $$('res2').hide(); // Hide certain elements on small screens
            }
        });
        var vthis = this; // Reference to the current instance
        var popupAddBeginDate = ''; // Initialize variable for popup
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2); // Format current date

        // Configuration for the popup to add the beginning date
        popupAddBeginDate = webix.ui({
            view: 'window',
            id: 'AddBeginDay',
            width: 450,
            height: 450,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Inicio Día'), align: 'center' }, // Popup header
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup
                            vthis.show('/top/dashboard'); // Redirect to dashboard
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Make the popup modal
            body: {
                view: 'form',
                id: 'addformBeginDay', // ID for the form in the popup
                elements: [
                    {
                        view: 'text',
                        label: _('Fecha: '), // Label for date field
                        labelWidth: 150,
                        name: 'CreatedLocalDate',
                        value: createdLocalDate, // Set current date as value
                        readonly: true, // Make field read-only
                    },
                    {
                        view: 'text',
                        type: 'number',
                        label: _('Valor Inicio de día:'), // Label for start value field
                        name: 'Value',
                        labelWidth: 150,
                        required: true, // Make field required
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: 'Cancelar', // Cancel button label
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup
                                    var vvthis = this;
                                    $$('addformBeginDay').setValues(
                                        $$('addformBeginDay').getCleanValues(), // Reset form values
                                    );
                                    vthis.show('/top/dashboard'); // Redirect to dashboard
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: 'Enviar', // Submit button label
                                click: function ($e) {
                                    var values = $$('addformBeginDay').getValues(); // Get form values
                                    if ($$('addformBeginDay').validate()) {
                                        // Validate form
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Accounting/SaveBeginDate',
                                                '{ "Amount":"' + values.Value + '"}', // Send start value
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Display error message
                                                        );
                                                        vthis.show(
                                                            '/top/dashboard', // Redirect to dashboard
                                                        );
                                                        $$('addformBeginDay').getTopParentView().hide(); // Hide popup
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response text to JSON
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: '¡Error!',
                                                                type: 'alert-error',
                                                                text: 'Ocurrio un error, comuniquese con soporte', // Error message
                                                            });
                                                            vthis.show(
                                                                '/top/dashboard', // Redirect to dashboard
                                                            );
                                                            $$('addformBeginDay').getTopParentView().hide(); // Hide popup
                                                        } else {
                                                            profile.BeginDay = true; // Set profile flag for beginning of day
                                                            webix.message(
                                                                'Inicio de día! ', // Success message
                                                            );
                                                            $$('addformBeginDay').setValues(
                                                                $$('addformBeginDay').getCleanValues(), // Reset form values
                                                            );
                                                            $$('addformBeginDay').getTopParentView().hide(); // Hide popup
                                                            vthis.getTopParentView().hide(); // Hide parent view
                                                            window.location.reload(); // Reload the page
                                                        }
                                                    },
                                                },
                                            );
                                    } else {
                                        webix.message({
                                            title: '¡Error!',
                                            type: 'alert-error',
                                            text: 'Completa los campos...', // Validation error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate fields on change
                        },
                    },
                },
            },
        });

        // Show the popup if the day has not begun
        if (!profile.BeginDay) {
            popupAddBeginDate.show();
        }
        console.log(profile); // Log the profile object for debugging
    }
}

// FILE DOCUMENTED
